// extracted by mini-css-extract-plugin
module.exports = {"bottom-sheet-overlay":"_1AKf","app-redirect":"_2wEY","closed":"qpwY","content":"_32DH","slogan":"_2d9m","close":"_3qzn"};